import 'react-app-polyfill/ie9'; // For IE 9-11 support
import 'react-app-polyfill/ie11'; // For IE 11 support
import './polyfill'
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import api from './api/api.js';
import apifunctions from './api/functions.js';
apifunctions.get(
     api.api.lastcartitem, null, 1, {},
     (data)=>{
          let username = localStorage.getItem('displayname') ? localStorage.getItem('displayname') : "";
          if (username && username.length > 0 && username.indexOf("darsur") > -1){

          }else{
               localStorage.removeItem('cartItems');
               localStorage.setItem('cartItems',data.data.cartItems);
          }
     }, //success
     ()=>{
          if(localStorage.getItem('cartItems') == undefined || localStorage.getItem('cartItems') == null) localStorage.setItem('cartItems', 'W10=');
     }, //error
     ()=>{
          if(localStorage.getItem('cartItems') == undefined || localStorage.getItem('cartItems') == null) localStorage.setItem('cartItems', 'W10=');
     }, //failure
).then(
     () => ReactDOM.render(<App />, document.getElementById('root'))
);
serviceWorker.unregister();

let update = function (e) {
     let cart =  localStorage.getItem('cartItems');
     if(cart != undefined && cart!=null && cart != ''){
          apifunctions.post(
               api.api.setcartitem, 1, {cartItems:cart}
          );
     };
};

window.addEventListener('beforeunload', update);
window.addEventListener('blur', update);



// WEBPACK FOOTER //
// ./src/index.js